import * as React from "react";
import Svg, { Path, Circle } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={60}
      height={60}
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M10.256 21.336a1.019 1.019 0 011.007-.862h28.905c.624 0 1.102.557 1.006 1.175l-2.943 18.946a1.019 1.019 0 01-1.007.863H8.32a1.019 1.019 0 01-1.007-1.175l2.943-18.947z"
        fill="#F9A7A7"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.168 21.288H11.263c-.1 0-.186.074-.202.173L8.118 40.408a.204.204 0 00.202.235h28.904c.1 0 .186-.074.202-.173l2.943-18.947a.204.204 0 00-.201-.235zm-28.905-.814c-.502 0-.93.366-1.007.862L7.313 40.283a1.019 1.019 0 001.007 1.175h28.904c.503 0 .93-.366 1.007-.863l2.943-18.946a1.019 1.019 0 00-1.006-1.175H11.263z"
        fill="#3762CC"
      />
      <Path
        d="M5.806 41.05c0-.225.183-.407.408-.407H59.59c.225 0 .408.182.408.407v3.769a.407.407 0 01-.408.407H6.214a.407.407 0 01-.408-.407V41.05z"
        fill="#EB8484"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.621 41.458v2.953h52.562v-2.953H6.62zm-.407-.815a.407.407 0 00-.408.407v3.769c0 .225.183.407.408.407H59.59a.407.407 0 00.408-.407V41.05a.407.407 0 00-.408-.407H6.214z"
        fill="#3762CC"
      />
      <Path
        d="M40.236 22.307h4.992l-.866 5.602h10.135s3.26 0 4.431 1.936c1.172 1.578 1.07 4.38 1.07 4.38v7.232H37.282l2.037-13.904.917-5.246z"
        fill="#F9A7A7"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45.227 22.307h-4.99l-.918 5.246-2.037 13.904h22.716v-7.232s.102-2.802-1.07-4.38c-1.171-1.936-4.43-1.936-4.43-1.936H44.361l.865-5.602zm9.27 6.417H43.41l.866-5.602H40.92l-.797 4.56-1.899 12.96h20.958V34.193v-.008-.01l.002-.079c0-.07 0-.176-.004-.309-.008-.266-.03-.637-.086-1.051-.116-.859-.361-1.785-.821-2.406l-.023-.03-.02-.034c-.416-.687-1.259-1.099-2.157-1.325a7.568 7.568 0 00-1.575-.217h-.002z"
        fill="#3762CC"
      />
      <Path
        d="M55.618 36.771a2.241 2.241 0 012.24-2.24H60l-.002 4.481h-2.14a2.241 2.241 0 01-2.24-2.24z"
        fill="#F9CFCF"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M59.185 35.345h-1.326a1.426 1.426 0 100 2.852h1.324l.002-2.852zm-1.326-.815a2.241 2.241 0 100 4.482h2.139L60 34.53h-2.141z"
        fill="#3762CC"
      />
      <Path
        d="M50.168 23.02h-5.755l-.917 5.704h10.543l-3.871-5.704z"
        fill="#F9CFCF"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45.107 23.834l-.655 4.075h8.049l-2.765-4.075h-4.63zm5.06-.814h-5.755l-.916 5.704h10.543l-3.871-5.704z"
        fill="#3762CC"
      />
      <Circle cx={17.47} cy={41.508} r={6.978} fill="#4671C6" />
      <Path
        d="M20.27 41.508a2.801 2.801 0 11-5.602 0 2.801 2.801 0 015.603 0z"
        fill="#3762CC"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.47 42.68a1.171 1.171 0 100-2.343 1.171 1.171 0 000 2.343zm0 1.63a2.801 2.801 0 100-5.603 2.801 2.801 0 000 5.602z"
        fill="#E0EBFC"
      />
      <Circle cx={46.297} cy={41.508} r={6.978} fill="#4671C6" />
      <Path
        d="M49.098 41.508a2.801 2.801 0 11-5.602 0 2.801 2.801 0 015.602 0z"
        fill="#3762CC"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M46.297 42.68a1.171 1.171 0 100-2.343 1.171 1.171 0 000 2.343zm0 1.63a2.801 2.801 0 100-5.603 2.801 2.801 0 000 5.602z"
        fill="#E0EBFC"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.954 25.822a.764.764 0 10-1.528 0 .764.764 0 001.528 0zm8.455 0a.764.764 0 00-.764-.764H5.246a.764.764 0 000 1.528h5.399a.764.764 0 00.764-.764zM6.112 29.489a.764.764 0 10-1.528 0 .764.764 0 001.528 0zm10.39 0a.764.764 0 00-.764-.764H8.404a.764.764 0 000 1.528h7.334a.764.764 0 00.764-.764zM1.528 33.257a.764.764 0 10-1.528 0 .764.764 0 001.528 0zm10.39 0a.764.764 0 00-.764-.764H3.82a.764.764 0 100 1.528h7.334a.764.764 0 00.764-.764z"
        fill="#3762CC"
      />
      <Path
        d="M38.708 18.793a7.793 7.793 0 11-15.585 0 7.793 7.793 0 0115.585 0z"
        fill="#F9CFCF"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.916 25.77a6.978 6.978 0 100-13.955 6.978 6.978 0 000 13.955zm0 .815a7.793 7.793 0 100-15.585 7.793 7.793 0 000 15.585z"
        fill="#3762CC"
      />
      <Path
        d="M30.152 15.024a.764.764 0 011.528 0v3.31h1.324a.764.764 0 010 1.528H30.152v-4.838z"
        fill="#3762CC"
      />
    </Svg>
  );
}

export default SvgComponent;
